// covered-by: frontends/carrie/src/ask-v2/shell/__tests__/AskV2Shell.test.tsx
import { Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { AskV2Home } from "../home/AskV2Home";

/**
 * V2 product chrome. Isolated from `/ask-puntt` and the tickets layout.
 * Home + transport live under `ask-v2/`, not in this file.
 */
export function AskV2Shell() {
  const { t } = useTranslation("ui");

  return (
    <main
      data-testid="ask-v2-shell"
      aria-label={t("askV2.shell.title")}
      className="flex min-h-screen flex-col bg-base-white"
    >
      <header className="flex flex-col gap-1 border-b border-puntt-neutral-gray-6 px-6 py-4">
        <Heading as="h1" size="5" data-testid="ask-v2-shell-title">
          {t("askV2.shell.title")}
        </Heading>
        <Text
          as="p"
          size="2"
          data-testid="ask-v2-shell-subtitle"
          className="text-puntt-neutral-gray-11"
        >
          {t("askV2.shell.subtitle")}
        </Text>
      </header>
      <AskV2Home />
    </main>
  );
}
